import React , {Component} from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Modal from 'react-modal';
import ModalUsuarios from './ModalUsuarios';
import Alert from 'react-s-alert';
import firebase from 'firebase';
import store from '../../store';
import copyright from '../../img/copyright-gray.png';
import { sendLog } from '../../util'

const database=firebase.database();

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '450px'	
  }
};

class Usuarios extends Component{
	
	constructor(props){
		
		super(props);
		this.state={
			usuarios:[],
			perfiles:[],
			isActive:false,
			nombre:'',
			contrasena:'',
			correo:'',
			estado:'',
			perfil:'',
			template:false,
			checkAdmin:false,
			sAdmin:false
							
		}
		
		this.handleClickUsuarios=this.handleClickUsuarios.bind(this);
		//Referencia para los usuarios
		this.UsuarioAcacyaRef=database.ref().child('Usuarios_Acacya');
		
		//Referencia para los perfiles
		this.PerfilesRef=database.ref().child('Perfiles');
		
		this.toggleModalUpdate=this.toggleModalUpdate.bind(this);
		
		//Funcion àra crear items para los select  de tipos de perfil
		this.MakeItems=this.MakeItems.bind(this);
		
		//Función para actulizar un registro
		this.updateRow=this.updateRow.bind(this);
		
		//Funcion para llamar ventana de confirmacion de cambios
		this.handleClickAlerta=this.handleClickAlerta.bind(this);
		
		this.ocultarMenu=this.ocultarMenu.bind(this);
		
		
		this.AlertaContenido = ({
		  id,
		  classNames,
		  styles,
		  message,
		  customFields,
		  handleClose,
		}) => {
		const handleConfirm = () => {
			
			this.updateRow();		
			Alert.close(id);
			this.setState({
				template:false
			})
		}
			return (
			<div className={classNames} id={id} style={styles}>
			  <div className='s-alert-box-inner'>
					{message}
			  </div>
			  <br/>
			  <br/>
			  <button className="customButton btn btn-success btn-alerts btn-m" onClick={handleConfirm.bind(this)}>Confirmar</button>
			  <button className="customButton btn btn-success btn-alerts btn-m-r" onClick={handleClose.bind(this)}>Cancelar</button>
			  <span className='s-alert-close' onClick={handleClose}></span>
			</div>
			);
		}
	}
	
	

	componentDidMount(){			
		this.UsuarioAcacyaRef.on('value', this.gotData, this.errData);		
		this.PerfilesRef.on('value',this.gotDataPerfil,this.errDataPerfil);
		this.checkSAdmin();
	}
	
	componentWillMount(){		
		this.UsuarioAcacyaRef.on('value', this.gotData, this.errData);		
		this.PerfilesRef.on('value',this.gotDataPerfil,this.errDataPerfil);
		Modal.setAppElement('body');
	}

	checkSAdmin = () => {
		let id = firebase.auth().currentUser.uid;
		firebase.database().ref("superAdmin").once("value").then(rows => {
			rows.forEach( element => {
				if (element.key === id) {
					this.setState({checkAdmin:true})
				}
			})
		})
	}

	handleInputChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;
		this.setState({
			[name]: value
		});
	}
	
	gotData = (data) => {
		
		  let newUsuario=[];
		  const usuariosdata = data.val();
		
		  //Si el nodo de usuarios no esta vacio
		  if(usuariosdata!=null){
			  
			  const keys = Object.keys(usuariosdata);
			
			  for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				
				newUsuario.push({
					key:k,
					contrasena:usuariosdata[k].contrasena,
					correo:usuariosdata[k].correo,
					estado:usuariosdata[k].estado,
					perfil:usuariosdata[k].perfil,
					nombre:usuariosdata[k].nombre
				  
				});
			  }
			 this.setState({usuarios: newUsuario});
			  
		  }
		
		}
		errData = (err) => {
	  console.log(err);
	}
	
	gotDataPerfil=(data)=>{
		
		let newPerfil=[];
		
		const perfilesdata=data.val();
		
		//Si el nodo de perfiles no esta vacio
		if(perfilesdata!=null){
			
			const keys = Object.keys(perfilesdata);
			
			for (let i = 0; i < keys.length; i++) {
				const k = keys[i];
				
				newPerfil.push({
					key:k,
					nombre:perfilesdata[k].nombre				  
				});				
			}
			 this.setState({perfiles: newPerfil});			
		}		
	}
	errDataPerfil=(err)=>{		
		console.log(err)
	}

	toggleModalUpdate(){
		
		this.setState({			
			isActive:!this.state.isActive			
		});
		
	}
	
	btnUsuariosFormatter(cell,row) {
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClickUsuarios(row)}} >Editar</button>;
	}
	
	//Retorna las opciones para llenar el select de los perfiles
	MakeItems(x){
		return <option>{x.nombre}</option>;		
	}
	
	
	handleClickUsuarios(row){
			
			this.setState({
				key:row.key,
				nombre:row.nombre,
				contrasena:row.contrasena,
				correo:row.correo,
				estado:row.estado,
				perfil:row.perfil
			})
			
			this.toggleModalUpdate();
		
	}
	
	
	updateRow(event){
		
		
		
		let key=this.state.key;
		let nombre=this.nombreUsuario.value;
		let correo=this.correoUsuario.value;
		let estado=this.estadoUsuario.value;
		let perfil=this.perfilUsuario.value;
		
		this.UsuarioAcacyaRef.child(key).update({
			nombre:nombre,
			correo:correo,
			estado:estado,
			perfil:perfil	
		})
		sendLog({ tipo: 'usuario_editado', informacion_extra: {usuario: key}});
		Alert.success('Datos actualizados correctamente', {
				effect: 'genie',
				position: 'bottom-right',
				timeout:2000
						
		});
		
		
		this.toggleModalUpdate();
		
	}
	
	handleClickAlerta(event){
		this.setState({
			template:true
			
		})
		const customerName = 'Acacya';
		Alert.success('¿Deseas confirmar los cambios?', {
		  position: 'top-right',
		  timeout:'none',		  
		  customFields: {
			customerName: customerName
		  }
		});
		
		event.preventDefault();
	}
	
	ocultarMenu(){
		

		store.dispatch({
			
			type: 'STATE_MOSTRAR',
			mostrar:'noMostrar'
		})
	}
	
	
	render(){
		 let {checkAdmin, sAdmin} = this.state;

		 return(
			
			<div className="usuarios container" onClick={this.ocultarMenu}>
						
						{this.state.template ? <Alert  timeout='none' contentTemplate={this.AlertaContenido} />:<Alert stack={{limit: 3}} html={true} />}
					<ModalUsuarios/>
					<BootstrapTable data={ this.state.usuarios}
							 ref='table'
							 pagination={ true }
							 search={ true }
							 hover
							 >
							<TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							<TableHeaderColumn dataField='nombre' dataSort={true}>Nombre del empleado</TableHeaderColumn>
							<TableHeaderColumn dataField='correo' dataSort={true}>Correo</TableHeaderColumn>
							<TableHeaderColumn dataField='perfil' >Perfil</TableHeaderColumn>
							<TableHeaderColumn dataField='estado'>Estado</TableHeaderColumn>
							{checkAdmin &&
								<TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnUsuariosFormatter.bind(this) }>Editar</TableHeaderColumn>
							}
					</BootstrapTable>		
					
						
					<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModalUpdate}  style={customStyles}>
						
					
						<form method="POST" action="" onSubmit={this.handleClickAlerta}>
						
						
							<h4>Editar Usuario</h4>							
							<hr/>
							<div className="form-group">
								<label htmlFor="">Nombre del empleado</label>
								<input type="text" name="" placeholder="Nombre del empleado" className="form-control" required autoComplete="off"								
								defaultValue={this.state.nombre}		
								ref={input => {this.nombreUsuario=input;}}

								/>
							</div>
							<div className="form-group">
								<label htmlFor="">Correo</label>
								<input type="text" name="" placeholder="Correo" className="form-control" required autoComplete="off"
								defaultValue={this.state.correo}
								ref={input => {this.correoUsuario=input;}}								
								/>
							</div>
							<div className="form-group">
								<label htmlFor="">Perfil</label>
								<select className="form-control" defaultValue={this.state.perfil} 
								ref={input => {this.perfilUsuario=input;}}
								>
									{this.state.perfiles.map(this.MakeItems)}
									
								</select>
							</div>
							{checkAdmin &&
							<div className="form-check" style={{marginBottom:10}}>
								<input name="sAdmin" className="form-check-input" type="checkbox" checked={sAdmin} onChange={this.handleInputChange} />
								<label className="form-check-label" htmlFor="defaultCheck1">
								Super Admin
								</label>
								<br></br>
                        	</div>
							}
							{sAdmin &&
								<div className="form-group">
									<label htmlFor="">Contraseña Administrador</label>
									<input type="password" name="" placeholder="Contraseña" className="form-control" required autoComplete="off"
									ref={input => {this.passwordAdmin=input;}}
									/>
								</div>
							}
							<div className="form-group">
								<label htmlFor="">Estado</label>
								<select className="form-control" defaultValue={this.state.estado}
								ref={input => {this.estadoUsuario=input;}}
								>
									<option value="Activo">Activo</option>
									<option value="Inactivo">Inactivo</option>
								</select>
							</div>							
							
						<button className="btn btn-primary buttons" type="submit" >Guardar</button>
						</form>
						<button className="btn btn-default buttons btnmargin" onClick={this.toggleModalUpdate}>Cerrar</button>
						
					</Modal> 
					<footer className="footer-pg mt-auto py-3" style={{width:'100%', position:'fixed'}}>
						<div className="container">
							<div className="row">
								<div className="col-md-4 col-sm-4">
								</div>
								<div className="col-sm">
									<img src={copyright}/>
								</div>
							</div>
						</div>
					</footer>
			</div>
		
		 );
	 }
}

export default Usuarios;



// WEBPACK FOOTER //
// ./src/Components/Usuarios/Usuarios.jsx